import React from "react";

import { Col, Container, Row } from "react-bootstrap";

import classNames from "classnames";

import { PendingApprovalUsers, useGetPendingApprovalUsersQuery } from "@api/graphql";
import { CustomAccordion } from "@components/accordion/CustomAccordion";

import { UsersTable } from "./Users";

import styles from "./index.module.scss";

const PendingApprovalUsersAccordionHeader = ({ data }: { data: PendingApprovalUsers[] }) => {
  return (
    <>
      <Col sm={3}>
        <Row className={classNames(styles["accounts"], "ms-2 b3")}>Users pending approval</Row>
      </Col>
      <Col className="d-flex justify-content-end">
        <Row className={classNames(styles["accounts"], "b3")}>{data?.length || 0} Users</Row>
      </Col>
    </>
  );
};

export const PendingApprovalUsersList = () => {
  const handleOnTableRowClick = () => {};

  const { data } = useGetPendingApprovalUsersQuery();

  const users = data?.getPendingApprovalUsers || [];

  return (
    <Container className="p-4" fluid>
      <Row className="pb-4">
        <CustomAccordion
          accordionKey="PendingApprovalUsers"
          header={<PendingApprovalUsersAccordionHeader data={users} />}
          contrastOpenStyle
          defaultActiveKey="PendingApprovalUsers"
          customHeaderStyle="px-2"
        >
          <div className="p-2 pt-0 d-flex justify-content-start align-items-start align-self-stretch flex-column">
            <UsersTable
              onRowClick={handleOnTableRowClick}
              users={users}
              customTableHeaders={[
                { label: "Account ID", accessor: "participant_id", className: styles["w-col-12"] },
                { label: "Account name", accessor: "account_name", className: styles["w-col-25"] },
                { label: "User name", accessor: "full_name", className: styles["w-col-12"] },
                { label: "Account type", accessor: "participant_type", className: styles["w-col-12"] },
                { label: "Join date", accessor: "date_created", className: styles["w-col-25"] },
                { label: "Account status", accessor: "user_status", className: styles["w-col-12"] },
              ]}
            />
          </div>
        </CustomAccordion>
      </Row>
    </Container>
  );
};
